export function getCookie(name: string): string {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1')}=([^;]*)`,
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
}

export function acceptCookie(name: string, value: string): void {
  const expiresDate = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365);

  document.cookie = `${name}=${value};expires=${expiresDate.toUTCString()}`;
}
